export const footerTemplatesStyle = {
  template1:{
    "footerStyle": "classic",
    "hasWave": false,
    "layout": {
      "mainRow": {
        "columns": [
          {
            "id": "brand",
            "width": 4,
            "sections": ["brand", "description"]
          },
          {
            "id": "products",
            "width": 4,
            "sections": ["productLinks"]
          },
          {
            "id": "company",
            "width": 4,
            "sections": ["companyLinks"]
          }
        ]
      },
      "bottomRow": {
        "columns": [
          { "id": "copyright", "width": 6 ,"styles": {
            "textAlign": 'start',
            "fontSize": '16px'
          }},
          { "id": "social", "width": 6 }
        ]
      }
    },
    "styleVars": {
      "--footer-muted": "#b4b4b4",
      "--footer-border": "rgba(255, 255, 255, 0.1)",
      "--overlay-opacity": "0.6",
      "--font-weight":"400",
      "--line-height": "24px",
      "--font-size": "18px",
      "--font-style": "normal",

    },
    "options": {
      "hasOverlay": true,
      "showLogo": true,
      "responsive": true
    }
  },
  template2: {
    "footerStyle": "compact",
    "hasWave": false,
    "layout": {
      "mainRow": {
        "columns": [
          {
            "id": "brand",
            "width": 6,
            "sections": ["brand", "description"]
          },
          {
            "id": "links",
            "width": 6,
            "sections": ["productLinks", "companyLinks"]
          }
        ]
      },
      "bottomRow": {
        "columns": [
          { "id": "copyright", "width": 6 ,"styles": {
            "textAlign": 'start',
            "fontSize": '16px'
          }},
          { "id": "social", "width": 6 }
        ]
      }
    },
    "styleVars": {
      "--footer-muted": "#b4b4b4",
      "--footer-border": "rgba(255,255,255,0.1)",
      "--overlay-opacity": "0.6",
      "--font-weight": "400",
      "--line-height": "24px",
      "--font-size": "18px",
      "--font-style": "normal"
    },
    
    "options": {
      "hasOverlay": true,
      "showLogo": true,
      "responsive": true
    }
  },
  template3: {
    footerStyle: 'line',
    hasWave: false,
    layout: {
      //  no main row at all
      mainRow: {
        columns: []
      },
  
      bottomRow: {
        columns: [
          { "id": "brand", "width": 3 },
          { "id": "copyright", "width": 6, "styles": {
            "textAlign": 'center',
            "fontSize": '16px'
          }},
          { "id": "social", "width": 3 }
        ]
      }
    },
  
    styleVars: {
      '--footer-border': 'none',
      "--overlay-opacity": "0.6",
      '--font-weight': '400',
      '--font-size': '16px',
      '--line-height': '24px'
    },

    options: {
      hasOverlay: false,
      showLogo: true,
      responsive: true,
      compact: true
    }
  },
  template4: {
    footerStyle: 'wave',
    hasWave: true,
    layout: {
      mainRow: {
        columns: [
          // ROW 1 – Social (centered)
          {
            id: 'socialRow',
            width: 12,
            sections: ['social'],
            styles: {
              justifyContent: 'center',
              marginBottom: '15px'
            }
          },
  
          // ROW 2 – Brand (centered)
          {
            id: 'brandRow',
            width: 12,
            sections: ['brand', 'description'],
            styles: {
              display:'flex',
              'flex-direction': 'column',
              justifyContent: 'center',
              textAlign: 'center',
              marginBottom: '32px',
              'align-items': 'center'
            }
          },
  
          // ROW 3 – Links
          {
            id: 'products',
            width: 6,
            sections: ['productLinks'],
            styles: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center'
            }
          },
          {
            id: 'company',
            width: 6,
            sections: ['companyLinks'],
            styles: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center'
            }
          },
        ]
      },

      // ROW 4 – Copyright
      bottomRow: {
        columns: [
          {
            id: 'copyright',
            width: 12,
            styles: {
              textAlign: 'center',
              fontSize: '16px'
            }
          }
        ]
      }
    },
    wave: {
      svg: `
        <svg viewBox="0 0 1821 142" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1809.62 78.1951C1809.62 78.1951 1663.42 47.5911 1550.62 49.8703C1457.78 51.7462 1304.66 78.1951 1304.66 78.1951C1304.66 78.1951 1196.25 53.6203 1117.48 52.2072C1026.9 50.5823 906.362 78.1951 906.362 78.1951C906.362 78.1951 785.144 53.8936 703.935 52.2072C607.65 50.2078 468.868 78.1951 468.868 78.1951C468.868 78.1951 357.835 58.7502 282.928 55.4806C180.622 51.0149 44.6933 79.9602 9.62305 86.6598" stroke="white" stroke-width="99.4995"/>
      <path d="M1810.26 29.5112L1809.74 119.51L1785.78 112.372L1759.84 101.722" stroke="white" stroke-width="20"/>
      <path d="M10 38.3662V128.366L34 121.366L60 110.866" stroke="white" stroke-width="20"/>
      </svg>
      `,
      styles: {
        width: '102%',
        display: 'block',
        color: 'currentColor'
      }
    },  
    styleVars: {
      '--footer-border': 'none',
      "--overlay-opacity": "0.6",
      '--font-weight': '400',
      '--font-size': '18px',
      '--line-height': '24px'
    },

    options: {
      hasOverlay: false,
      showLogo: true,
      responsive: true,
      hasWave: true,
      compact: false
    }
  },
  template5: {
    footerStyle: 'wrap',
    showFloatingBar: true,
    hasWave: false,
    layout: {
      // Floating Bar configuration
      floatingBar: {
        svg:
        `<svg viewBox="0 0 1440 122" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 -93.25H1440V31.1565C1440 31.1565 1079.43 121.75 719.621 121.75C359.81 121.75 0 31.1565 0 31.1565V-93.25Z" fill="white"/>
        </svg>`,
        columns: [
          {
            id: 'floatingContent',
            width: 12,
            sections: ['brand', 'description'],
            styles: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              gap: '5px'
            }
          }
        ],
        styles: {
          position: 'relative',
          width: '90%',
          maxWidth: '1250px',
          background: '#0A0A0A',
          borderRadius: '40px',
          padding: '20px 30px',
          textAlign: 'center',
          // boxShadow: '0 30px 80px rgba(0, 0, 0, 0.75), inset 0 1px 0 rgba(255, 255, 255, 0.05)'
        },
        
      },

      mainRow: {
        columns: [
          {
            id: 'products',
            width: 8,
            sections: ['productLinks'],
            styles: {
             padding: '20px 35px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              textAlign: 'center'
            
            },
            linkStyle: {
              display: 'flex',
              alignItems: 'center',
              gap: '15px'
            }
          },
          {
            id: 'social',
            width: 4,
            sections: ['social'],
            styles: {
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-start',
              paddingTop: '20px'
            }
          }
        ]
      },

      bottomRow: {
        columns: [
          {
            id: 'copyright',
            width: 6,
            styles: {
              textAlign: 'left',
              fontSize: '16px'
            }
          },
          {
            id: 'company',
            width: 6,
            sections: ['companyLinks'],
            styles: {
              textAlign: 'right'
            },
            linkStyle: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '15px'
            }
          }
        ]
      }
    },

    styleVars: {
      "--footer-border": "rgba(255, 255, 255, 0.1)",
      '--overlay-opacity': '0.6',
      '--font-weight': '400',
      '--font-size': '18px',
      '--line-height': '24px'
    },

    options: {
      hasOverlay: true,
      showLogo: true,
      responsive: true,
      compact: false
    }
  },  
  template6: {
    footerStyle: 'ImageFooter',
    hasWave: false,
    footerBgImageUrl:"https://firebasestorage.googleapis.com/v0/b/neat-planet-378416.appspot.com/o/project_assets%2F9378%2Fimages%2Ffooter_bg_image.png?alt=media&token=0559bea7-58e4-4028-b373-bc8a4fcc85a2",
    layout: {
      mainRow: {
        columns: [
          // ROW 1 – BRAND (center)
          {
            id: 'brandRow',
            width: 12,
            sections: ['brand', 'description'],
            styles: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              marginBottom: '32px'
            }
          },
  
          // ROW 2 – LINKS
          {
            id: 'products',
            width: 6,
            sections: ['productLinks'],
            styles: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center'
            }
          },
          {
            id: 'company',
            width: 6,
            sections: ['companyLinks'],
            styles: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center'
            }
          },
  
        // ROW 3 – SOCIAL BOX (title + icons inside)
        {
          id: 'socialBox',
          width: 12,
          sections: ['socialBox'],
          styles: {
            display: 'flex',
            justifyContent: 'center',
            'align-items': 'center',
          },
          titleStyles: {
            fontSize: '22px',
            fontWeight: '700'
          },
          boxStyle:{
            display: 'flex',
            justifyContent: 'center',
            'border-radius': '12px',
            padding: '20px',
            gap: '10px',
            'align-items': 'center',
            'flex-direction': 'column',
            background: 'rgba(255, 255, 255, 0.85)',
            color:'#000'

          }
        }
        ]
      },
  
      //  ROW 5 – COPYRIGHT (LEFT)
      bottomRow: {
        columns: [
          {
            id: 'copyright',
            width: 6,
            styles: {
              textAlign: 'left',
              fontSize: '16px'
            }
          }
        ]
      }
    },
  
    styleVars: {
      '--footer-border': 'none',
      '--overlay-opacity': '0.6',
      '--font-weight': '400',
      '--font-size': '18px',
      '--line-height': '24px'
    },
  
    options: {
      hasOverlay: true,
      showLogo: true,
      responsive: true,
      compact: false
    }
  }
  
  
  
}

